// Store implementation for reactive state management
// noinspection JSUnusedGlobalSymbols

(function(app) {
    app.Store = {
        state: {
            // Core state
            initialized: false,
            cartReady: false,
            canvasReady: false,
            builderType: 'none', // Type of builder ('none', 'text', 'flag', etc)

            // Text state
            text: '',
            textColor: '',
            font: '',
            justification: 'center',
            mirrored: false,
            italic: false,
            bold: false,

            // Flag state
            flagPosition: 'left', // 'left' or 'right' of text
            
            // Canvas state
            size: {width: 0, height: 0},
            lineTwoEnabled: false,
            isSet: false,
            attributes: [],
            layerColors: [],

            // Cart state
            quantity: 1,
            discount: 0,
            price: {
                base: 0,
                unit: 0,
                total: 0,
                formatted: '0 kr'
            },
            cartUpdate: false,
            isCalculatingPrice: false
        },

        listeners: new Map(),

        /**
         * Subscribe to state changes
         * @param {string} key - State key to subscribe to
         * @param {function} callback - Callback function
         * @returns {function} - Unsubscribe function
         */
        subscribe(key, callback) {
            if (!this.listeners.has(key)) {
                this.listeners.set(key, new Set());
            }
            this.listeners.get(key).add(callback);

            // Return unsubscribe function
            return () => {
                const listeners = this.listeners.get(key);
                if (listeners) {
                    listeners.delete(callback);
                }
            };
        },

        /**
         * Update state and notify subscribers
         * @param {string} key - State key to update
         * @param {*} value - New value
         * @param {boolean} silent - If true, don't notify subscribers
         */
        setState(key, value, silent = false) {
            const oldValue = this.state[key];
            this.state[key] = value;

            if (!silent && this.listeners.has(key)) {
                this.listeners.get(key).forEach(callback => {
                    callback(value, oldValue);
                });
            }
        },

        /**
         * Get state value
         * @param {string} key - State key
         * @returns {*} State value
         */
        getState(key) {
            return this.state[key];
        },

        /**
         * Batch multiple state updates
         * @param {Object} updates - Key-value pairs of updates
         */
        batchUpdate(updates) {
            // First update all states silently
            Object.entries(updates).forEach(([key, value]) => {
                this.setState(key, value, true);
            });

            // Then notify all affected subscribers
            Object.keys(updates).forEach(key => {
                if (this.listeners.has(key)) {
                    this.listeners.get(key).forEach(callback => {
                        callback(this.state[key], null);
                    });
                }
            });
        },

        /**
         * Initialize the store with default values
         * @param {Object} initialState - Initial state values
         */
        init(initialState = {}) {
            this.state = {...this.state, ...initialState};
        }
    };
})(window.app = window.app || {});